/**
 * @generated SignedSource<<eb41958cf6d809a18544f93cffccdb90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineScheduleType = "DAILY" | "MONTHLY" | "WEEKLY";
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleContentSectionHeader_teamSchedule$data = {
  readonly freq: RoutineScheduleType;
  readonly id: string;
  readonly label: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentStatus_teamSchedule">;
  readonly " $fragmentType": "WidgetTeamScheduleContentSectionHeader_teamSchedule";
};
export type WidgetTeamScheduleContentSectionHeader_teamSchedule$key = {
  readonly " $data"?: WidgetTeamScheduleContentSectionHeader_teamSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentSectionHeader_teamSchedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleContentSectionHeader_teamSchedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "freq",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTeamScheduleContentStatus_teamSchedule"
    }
  ],
  "type": "TeamSchedule",
  "abstractKey": null
};

(node as any).hash = "100c5413bb4bfcb05b537eaf7a636f93";

export default node;
